import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ADPHeaderFactoryService, EncriptionService, RequestCriticalLevel, ADPResourceService as ResourceService, StorageService } from 'digital-core';
import { ConfigService } from './config.service';
import { TokenService } from './token.service';
import * as CryptoJS from 'crypto-js';
@Injectable()
export class HeaderFactoryService extends ADPHeaderFactoryService {
  constructor(
    private tokenService: TokenService,
    private _configService: ConfigService,
    private _storageService: StorageService,
    private resourceService: ResourceService,
    private encriptionService: EncriptionService,
  ) {
    super(_configService, _storageService);
  }

  public getAuthorizationHeaderOptions(
    customHeaders: string[] = null,
    level: RequestCriticalLevel = RequestCriticalLevel.Default,
    formData:FormData=null
  ) {

    let secureHttpOptions = { headers: null };
    const localLanguage = this._storageService.getLocal<string>(`language`);

    if (customHeaders != null && customHeaders.length > 0) {
      if (localStorage.getItem('X-Forwarded-For')) {
        secureHttpOptions.headers = new HttpHeaders({
          Accept: 'application/json',
          'X-Forwarded-For': localStorage.getItem('X-Forwarded-For'),
          Authorization: `Bearer ${this.tokenService.getCurrentAccessToken()}`,
        })
          .set(level, 'true')
          .set('ClientCMS', this._configService.clientCMS)
          .set('ParentCMS', this._configService.parentCMS)
          .set('Culture', localLanguage ? localLanguage : this._configService.language)
          .set('program', this._configService.program)
          .set('ClientName', this._configService.getClientName())
          .set('SystemRole', this._configService.systemRole)
          .set('ClientId', this._configService.clientId)
          .set('X-Request-Hash',formData? this.getRequestHash(formData):'');
          
        return secureHttpOptions;
      }

      secureHttpOptions.headers = new HttpHeaders({
        Accept: 'application/json',
        Authorization: `Bearer ${this.tokenService.getCurrentAccessToken()}`,
      })
        .set(level, 'true')
        .set('ClientCMS', this._configService.clientCMS)
        .set('ParentCMS', this._configService.parentCMS)
        .set('Culture', localLanguage ? localLanguage : this._configService.language)
        .set('program', this._configService.program)
        .set('ClientName', this._configService.getClientName())
        .set('ClientId', this._configService.clientId)
        .set('isSSOEnabled', this._configService.isSSOEnabled.toString())
        .set('X-Request-Hash',formData? this.getRequestHash(formData):'');
      return secureHttpOptions;
    }
    if (localStorage.getItem('X-Forwarded-For')) {
      secureHttpOptions.headers = new HttpHeaders({
        Accept: 'application/json',
        'X-Forwarded-For': localStorage.getItem('X-Forwarded-For'),
        Authorization: `Bearer ${this.tokenService.getCurrentAccessToken()}`,
      }).set(level, 'true')
        .set('ClientCMS', this._configService.clientCMS)
        .set('ParentCMS', this._configService.parentCMS)
        .set('Culture', localLanguage ? localLanguage : this._configService.language)
        .set('program', this._configService.program)
        .set('ClientName', this._configService.getClientName())
        .set('ClientId', this._configService.clientId)
        .set('isSSOEnabled', this._configService.isSSOEnabled.toString())
        .set('X-Request-Hash',formData? this.getRequestHash(formData):'');
      return secureHttpOptions;
    }

    secureHttpOptions.headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: `Bearer ${this.tokenService.getCurrentAccessToken()}`,
    }).set(level, 'true').set('ClientCMS', this._configService.clientCMS)
      .set('ParentCMS', this._configService.parentCMS)
      .set('Culture', localLanguage ? localLanguage : this._configService.language)
      .set('program', this._configService.program)
      .set('ClientName', this._configService.getClientName())
      .set('ClientId', this._configService.clientId)
      .set('isSSOEnabled', this._configService.isSSOEnabled.toString())
      .set('X-Request-Hash',formData? this.getRequestHash(formData):'');
          
    return secureHttpOptions;
  }

  public continueSpinnerHeaderOptions() {
    const httpHeaders = this.getAuthorizationHeaderOptions(null, RequestCriticalLevel.Critical);
    httpHeaders.headers = httpHeaders.headers.set('continueProgressForChainRequest', 'true');

    return httpHeaders;
  }

  public getFileAuthorizationHeaderOptions(
    level: RequestCriticalLevel = RequestCriticalLevel.Default
  ) {
    const secureHttpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: `Bearer ${this.tokenService.getCurrentToken()}`,
      }).set(level, 'true'),
    };
    return secureHttpOptions;
  }

  public getLazyLoadHeaders() {
    let httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        lazy: '',
        ClientCMS: this._configService.clientCMS,
        ParentCMS: this._configService.parentCMS,
        'x-api-request-id': this.getApiRequestId(),
      }).set(RequestCriticalLevel.Low, 'true'),
    };
    return httpOptions;
  }

  public getBasicHeaderOptions(
    customHeaders: string[] = null,
    observeResponse: boolean = false,
    level: RequestCriticalLevel = RequestCriticalLevel.Default
  ) {
    if (customHeaders != null && customHeaders.length > 0) {
      if (observeResponse) {
        let httpOptions = {
          headers: new HttpHeaders({
            Accept: 'application/json',
          })
            .set(level, 'true')
            .set('ClientCMS', this._configService.clientCMS)
            .set('ParentCMS', this._configService.parentCMS)
            .set('Culture', this._configService.language)
            .set('program', this._configService.program)
            .set('ClientName', this._configService.getClientName())
            .set('ClientId', this._configService.clientId),
          observe: 'response',
        };

        return httpOptions;
      } else {
        let httpOptions = {
          headers: new HttpHeaders({
            Accept: 'application/json',
          })
            .set(level, 'true')
            .set('ClientCMS', this._configService.clientCMS)
            .set('ParentCMS', this._configService.parentCMS)
            .set('Culture', this._configService.language)
            .set('program', this._configService.program)
            .set('ClientName', this._configService.getClientName()),
        };
        return httpOptions;
      }
    }
    if (observeResponse) {
      let httpOptions = {
        headers: new HttpHeaders({
          Accept: 'application/json',
        }).set(level, 'true'),
        observe: 'response',
      };

      return httpOptions;
    } else {
      let httpOptions = {
        headers: new HttpHeaders({
          Accept: 'application/json',
        }).set(level, 'true'),
      };
      return httpOptions;
    }
  }

  public getOktaHeaderOptions(
    level: RequestCriticalLevel = RequestCriticalLevel.Default
  ) {
    let httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        client_id: '0oau3upxi76maqgxw0h7',
        response_type: 'code',
        response_mode: 'query',
        scope: 'openid offline_access',
      }).set(level, 'true'),
    };
    return httpOptions;
  }
  public getOktaBasicAuthenticationHeaderOptions(
    level: RequestCriticalLevel = RequestCriticalLevel.Default
  ) {
    let httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization:
          'Basic ' +
          btoa(
            `${this._configService.oktaClientId}:${this._configService.oktaClientSecret}`
          ),
        'Content-Type': 'application/x-www-form-urlencoded',
      }).set(level, 'true'),
    };
    return httpOptions;
  }
  public getBasicHeaderOption(
    observeResponse: boolean = false,
    level: RequestCriticalLevel = RequestCriticalLevel.Default
  ) {
    if (observeResponse) {
      let httpOptions = {
        headers: new HttpHeaders({
          Accept: 'application/json',
          Authorization: `Bearer ${this.tokenService.getCurrentAccessToken()}`,
        }).set(level, 'true')
          .set('ClientCMS', this._configService.clientCMS)
          .set('ParentCMS', this._configService.parentCMS)
          .set('Culture', this._configService.language)
          .set('program', this._configService.program)
          .set('ClientName', this._configService.getClientName()),
        responseType: 'blob',
      };

      return httpOptions;
    } else {
      let httpOptions = {
        headers: new HttpHeaders({
          Accept: 'application/json',
        })
          .set(level, 'true')
          .set('ClientCMS', this._configService.clientCMS)
          .set('ParentCMS', this._configService.parentCMS)
          .set('Culture', this._configService.language)
          .set('program', this._configService.program)
          .set('ClientName', this._configService.getClientName()),
      };
      return httpOptions;
    }
  }

  public getAuthorizationHeaderOptionsFile(
    level: RequestCriticalLevel = RequestCriticalLevel.Default
  ) {
    const secureHttpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/octet-stream',
        Authorization: `Bearer ${this.tokenService.getCurrentToken()}`,
      }).set(level, 'true'),
    };
    return secureHttpOptions;
  }
  public getPublicMulesoftHeaderOptions(
    level: RequestCriticalLevel = RequestCriticalLevel.Default
  ) {
    const secureHttpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'x-api-client-name': this.getClientName(),
        'x-api-request-id': this.getApiRequestId(),
        ClientCMS: this._configService.clientCMS,
        ParentCMS: this._configService.parentCMS,
      }).set(level, 'true'),
    };
    return secureHttpOptions;
  }

  public getAuthorizationHeaderOptionsForDocumentDownload(
    level: RequestCriticalLevel = RequestCriticalLevel.Default
  ) {
    const secureHttpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Accept: 'application/octet-stream',
        Authorization: `Bearer ${this.tokenService.getIdToken()}`,
        'x-api-client-name': this.getClientName(),
        'x-api-request-id': this.getApiRequestId(),
        ClientCMS: this._configService.clientCMS,
        ParentCMS: this._configService.parentCMS,
      }).set(level, 'true'),
    };
    return secureHttpOptions;
  }


  isStringValidForHeader(str: string): boolean {
    let code: number;
    for (let i = 0; i < str.length; i++) {
      code = str.charCodeAt(i);
      const val = this.isAlphaNumeric(code);
      if (!val) {
        const allowedCharListFromSF = this.resourceService.getPortalSetting('Global_Allowed_Characters');
        if (!!allowedCharListFromSF) {
          const allowedCharArray = allowedCharListFromSF.Value.split(',');
          var isValueMatched = allowedCharArray.some(x => Number(x) == str.charCodeAt(i));
          if (!isValueMatched) {
            return false;
          }
        }
      }
    }
    return true;
  }

  isAlphaNumeric(code: number): boolean {
    if (!(code > 47 && code < 58) && // numeric (0-9)
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123)) { // lower alpha (a-z)
      return false;
    }
    return true;
  }

  ValidateAndManipulateHTTPHeaders(request: HttpRequest<any>): HttpRequest<any> {
    let newRequest = request;
    const allHeaders = newRequest.headers.keys();
    allHeaders.forEach((header: string) => {
      let headerValue = newRequest.headers.get(header);
      if (headerValue && header!='RequestHash') {
        let isHeaderValid = this.isStringValidForHeader(headerValue);
        if (!isHeaderValid) {
          console.log('', 'This HttpRequest  does not have  Valid Header,', '\n',
            'URL : ' + newRequest.url + '', '\n', 'Header Name : ' + header + '', '\n', 'Header Value : ' + headerValue + '');
          newRequest = newRequest.clone({ headers: newRequest.headers.set(header, '') });
        }
      }
    });
    return newRequest;
  }

  getRequestHash(formBody:any):string{
    let hash=null;
    let formattedData;
      if (formBody) {
      if (formBody instanceof FormData) {
        formBody.forEach(element => {
          formattedData = element;
        });
      }
      else {
        formattedData = JSON.stringify(formBody)
      }
       hash = CryptoJS.HmacSHA256(formattedData?.replace(/\"/g, ''), this._configService.getAPIRequestEncryptionKey).toString(CryptoJS.enc.Hex);
    }
   return hash;
  }

  getRandomSecret(){
   return (self.crypto.randomUUID() + self.crypto.randomUUID()).replace(/-/g, '').substr(0, 32);
  }
}
